import { getTodayDateString, toLocalDateString, fromLocalDateString } from "./date-utils"
import { subDays } from "date-fns"

export interface DailyEntry {
  id: string
  date: string
  zoneId: string
  note?: string | null
}

const STORAGE_KEY = "inner-scale-entries"

export function saveEntry(entry: Omit<DailyEntry, "id">): DailyEntry {
  const entries = getEntries()
  const newEntry: DailyEntry = {
    ...entry,
    id: crypto.randomUUID(),
  }
  entries.push(newEntry)
  localStorage.setItem(STORAGE_KEY, JSON.stringify(entries))
  return newEntry
}

export function getEntries(): DailyEntry[] {
  if (typeof window === "undefined") return []
  const data = localStorage.getItem(STORAGE_KEY)
  return data ? JSON.parse(data) : []
}

export function getTodayEntry(): DailyEntry | undefined {
  const today = getTodayDateString()
  const entries = getEntries()
  return entries.find((e) => e.date === today)
}

export function getEntriesInRange(days: number): DailyEntry[] {
  const entries = getEntries()
  const cutoffDate = subDays(new Date(), days)
  const cutoffDateStr = toLocalDateString(cutoffDate)
  return entries.filter((e) => e.date >= cutoffDateStr)
}

export function saveOrUpdateTodayEntry(entry: Omit<DailyEntry, "id">): DailyEntry {
  const entries = getEntries()
  const today = getTodayDateString()

  // Find existing entry for today
  const existingIndex = entries.findIndex((e) => e.date === today)

  if (existingIndex >= 0) {
    // Update existing entry
    const updatedEntry: DailyEntry = {
      ...entries[existingIndex],
      ...entry,
    }
    entries[existingIndex] = updatedEntry
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries))
    return updatedEntry
  } else {
    // Create new entry
    const newEntry: DailyEntry = {
      ...entry,
      id: crypto.randomUUID(),
    }
    entries.push(newEntry)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries))
    return newEntry
  }
}
